var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmarkCircle = function SvgCheckmarkCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m12.568 6.997-3.154 4.14L8.054 9.4a.832.832 0 1 0-1.313 1.027l2.026 2.59c.158.2.4.318.656.318h.006c.258 0 .501-.122.657-.328l3.807-5a.832.832 0 1 0-1.325-1.01Zm-2.254 9.671a6.674 6.674 0 0 1-6.667-6.667 6.674 6.674 0 0 1 6.667-6.666A6.674 6.674 0 0 1 16.98 10a6.675 6.675 0 0 1-6.666 6.667Zm0-15a8.334 8.334 0 1 0 0 16.667 8.334 8.334 0 0 0 0-16.667Z",
    fill: "#0B3E21"
  })));
};
export default SvgCheckmarkCircle;